if (!customElements.get('cart-terms')) {
  class CartTerms extends HTMLElement {
    constructor() {
      super();
      this.cartTermsCheckbox = this.querySelector('.js-cart-terms-checkbox');
      this.modal = this.querySelector('[data-cart-terms-modal]');
      this.pageModal = this.querySelector('[data-cart-terms-page-modal]');
      this.form = document.getElementById(this.cartTermsCheckbox.getAttribute('form'));
      this.submitter = null;
      this.submitHandler = this.handleSubmit.bind(this);
      this.form.addEventListener('submit', this.submitHandler);
      this.modal.querySelector('[data-cart-terms-accept]').addEventListener('click', this.handleAccept.bind(this));
      this.addEventListener('click', this.handleClick.bind(this));
    }

    disconnectedCallback() {
      this.form.removeEventListener('submit', this.submitHandler);
    }

    /**
     * Handles cart form submit
     * @param {object} evt - Event object.
     */
    handleSubmit(evt) {
      if (!this.cartTermsCheckbox.checked) {
        evt.preventDefault();
        this.submitter = evt.submitter;
        this.modal.showModal();
      }
    }

    /**
     * Accepts the terms and continues to checkout with the original submit button.
     */
    handleAccept() {
      this.cartTermsCheckbox.checked = true;
      this.modal.close();
      this.form.requestSubmit(this.submitter);
    }

    /**
     * Opens the terms page modal from terms links and closes modals from close buttons or the backdrop.
     * @param {object} evt - Event object.
     */
    handleClick(evt) {
      const closeButton = evt.target.closest('[data-cart-terms-close]');
      if (closeButton) {
        closeButton.closest('dialog').close();
        return;
      }

      if (evt.target.tagName === 'DIALOG') {
        evt.target.close();
        return;
      }

      const link = evt.target.closest('a');
      if (link && this.pageModal && link.pathname === this.pageModal.dataset.pageUrl) {
        evt.preventDefault();
        this.pageModal.showModal();
      }
    }
  }
  customElements.define('cart-terms', CartTerms);
}
